import { render, staticRenderFns } from "./InviteUserToProject.vue?vue&type=template&id=770f2668&scoped=true&"
import script from "./InviteUserToProject.vue?vue&type=script&lang=ts&"
export * from "./InviteUserToProject.vue?vue&type=script&lang=ts&"
import style0 from "./InviteUserToProject.vue?vue&type=style&index=0&id=770f2668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f2668",
  null
  
)

export default component.exports